export function Exchange({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <g transform="translate(-865 -172)">
        <path
          d="M2154,690s.12.849,3.64,4.364A9.008,9.008,0,0,0,2172.78,690M2154,690v6m0-6h6m14-4s-.12-.849-3.64-4.364A9.008,9.008,0,0,0,2155.22,686m18.78,0v-6m0,6h-6"
          transform="translate(-1287 -504)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
